import { reverse } from "lodash";

export type Drum =
  | "BD"
  | "CB"
  | "CH"
  | "CL"
  | "CP"
  | "CY"
  | "HC"
  | "HT"
  | "LC"
  | "LT"
  | "MA"
  | "MC"
  | "MT"
  | "OH"
  | "RS"
  | "SD"
  | "AC";
export type Note =
  | "C"
  | "C#"
  | "D"
  | "D#"
  | "E"
  | "F"
  | "F#"
  | "G"
  | "G#"
  | "A"
  | "A#"
  | "B";

export type Hit<C> = {
  readonly type: "drum" | "bass";
  readonly timeStep: number;
  readonly note: C;
};

export type DrumHit = Hit<Drum> & {
  readonly type: "drum";
};
export type BassHit = Hit<Note> & {
  readonly type: "bass";
  readonly slide: boolean;
  readonly accent: boolean;
  readonly octave: number;
};

export type Machine = "tr808" | "tb303";

export type MachineState = {
  readonly playing: boolean;
};
export type TR808State = MachineState & {
  readonly layout: {
    readonly timeSteps: number;
    readonly rows: readonly Drum[];
  };
  readonly sequence: readonly DrumHit[];
  readonly fillSequence: readonly DrumHit[];
  readonly aiVariationSequence: readonly DrumHit[];
  readonly fillCount: number;
  readonly shuffle: number;
  readonly aiVariationOn: boolean;
};
export type TB303ControlState = {
  readonly cutOffFreq: number;
  readonly resonance: number;
  readonly envMod: number;
  readonly decay: number;
  readonly accent: number;
};
export type TB303Waveform = "sawtooth" | "square";
export type TB303State = MachineState & {
  readonly layout: {
    readonly timeSteps: number;
    readonly rows: readonly Note[];
  };
  readonly sequence: readonly BassHit[];
  readonly waveform: TB303Waveform;
  readonly controls: TB303ControlState;
};

export type MarchSubscriber = (
  timeStep: number,
  previousTimestep: number,
  hits: string[],
  triggerTime: number,
  phantom?: boolean
) => void;

export const NOTES: Note[] = [
  "C",
  "C#",
  "D",
  "D#",
  "E",
  "F",
  "F#",
  "G",
  "G#",
  "A",
  "A#",
  "B",
];
export const MIN_BPM = 30;
export const MAX_BPM = 200;

export const LARGE_SCREEN_TIMESTEPS = 16;
export const SMALL_SCREEN_TIMESTEPS = 8;

export const LARGE_SCREEN_DRUMS: Drum[] = [
  "CH",
  "OH",
  "CY",
  "CB",
  "CP",
  "RS",
  "HT",
  "MT",
  "LT",
  "SD",
  "BD",
  "AC",
];
export const SMALL_SCREEN_DRUMS: Drum[] = ["CH", "OH", "CB", "LT", "SD", "BD"];

export const LARGE_SCREEN_NOTES = reverse(NOTES);

export const SMALL_SCREEN_NOTES: Note[] = ["A#", "G", "F#", "F", "D#", "C"];
